import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
// import calendarSaga from "./calendar/saga"
import chatSaga from "./chat/saga"
import ecommerceSaga from "./e-commerce/saga"
import invoiceSaga from "./invoices/saga"
import contactsSaga from "./contacts/saga"
import adminsSaga from "./admins/saga"
import ceremoniesSaga from "./ceremony/saga"
import vendor_catsSaga from "./vendor_cat/saga"
import vendorSaga from "./vendor/saga"
import addressSaga from "./address/saga"
import ceremony_typeSaga from "./ceremony-pack/saga"
import vendor_mediaSaga from "./vendor_media/saga"
import vendor_pricingSaga from "./vendor_pricing/saga"
import vendor_eventSaga from "./vendor_events/saga"
import clients from "./clients/saga"
import purchases from "./purchases/saga"
import events from "./events/saga"
import typeServices from "./vendor_types_services/saga"
import typeSettings from "./vendor_types_settings/saga"
import budget_percentage from "./budget-percentage/saga"
import settings from "./settings/saga"
import howitwork from "./how_it_works/saga"
import faq from "./faq/saga"
import reviews from "./reviews/saga"
// import popup from "./popup/saga"

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    fork(LayoutSaga),
    // fork(calendarSaga),
    fork(chatSaga),
    fork(ecommerceSaga),
    fork(invoiceSaga),
    fork(contactsSaga),
    fork(adminsSaga),
    fork(ceremoniesSaga),
    fork(vendor_catsSaga),
    fork(vendorSaga),
    fork(addressSaga),
    fork(ceremony_typeSaga),
    fork(vendor_mediaSaga),
    fork(vendor_pricingSaga),
    fork(vendor_eventSaga),
    fork(clients),
    fork(purchases),
    fork(budget_percentage),
    fork(settings),
    // fork(popup),
    fork(events),
    fork(typeServices),
    fork(typeSettings),
    fork(howitwork),
    fork(faq),
    fork(reviews)

  ])
}
